import { inject, Injectable } from '@angular/core';
import { User, UserPreferences } from './User';
import { doc, docData } from '@angular/fire/firestore';
import { Firestore } from 'firebase/firestore';
import { AuthService } from 'src/services/auth/auth.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  public user = new BehaviorSubject<User | null>(null);

  async update(user: User): Promise<void> {
    throw new Error('Method not implemented.');
  }

  async savePreferredTagOrder(ids: string[]) {
    throw new Error('Method not implemented.');
  }
}
